/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Ruleset list and editor (reuses blocklist usage chrome).
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {ButtonsModule} from 'ngx-bootstrap/buttons';

import {AppSharedModule} from '../common/app-shared.module';
import {AdnSelectModule} from '../common/directives/adn-select/adn-select.module';
import {AdminListModule} from '../common/directives/admin-list.module';
import {FormControlsModule} from '../common/directives/form-controls/form-controls.module';
import {BlocklistModule} from '../blocklist/blocklist.module';
import {RulesetEditPageComponent} from './ruleset-edit-page.component';
import {RulesetListPageComponent} from './ruleset-list-page.component';
import {RulesetRoutePageComponent} from './ruleset-route-page.component';

const RULESET = [
  RulesetEditPageComponent,
  RulesetListPageComponent,
  RulesetRoutePageComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    UIRouterModule,
    ButtonsModule,
    AdnSelectModule,
    AdminListModule,
    FormControlsModule,
    BlocklistModule
  ],
  declarations: RULESET,
  exports: RULESET
})
export class RulesetModule {
}
